import React from 'react';

type Props = React.PropsWithChildren<{
  id?: string;
  htmlFor?: string;
  required?: boolean;
  className?: string;
}>;

export default function FieldLabel({ id, htmlFor, required, className, children }: Props) {
  return (
    <label id={id} htmlFor={htmlFor} className={className}>
      {required ? (
        <span className='req' aria-hidden>
          *{' '}
        </span>
      ) : null}
      {children}
    </label>
  );
}
